import Layout from './layout';
import TextAnimation from './textAnim';
import HeadAnimation from './head';
import './speakers'
// import './timer' // таймер

import Vue from 'vue';
import PageForm from "vue/PageForm.vue";
import window from "inputmask/lib/global/window";
import {checkInitGoogleAnalytics, getCookie, mindboxAnonimEdit, mindboxAnonimEditSetEntrancePage} from "~/helpers";


if (document.getElementById('vue-page-form')) {
  const vuePageForm = new Vue({
    el: '#vue-page-form',
    render: h => h(PageForm)
  });
}

const textAnim = new TextAnimation();
const layout = new Layout();
const headAnim = new HeadAnimation();
headAnim.headAnim();


document.addEventListener('DOMContentLoaded', () => {

  document.querySelectorAll('video[autoplay]').forEach(video => video.play());
  // <!-- Google Tag Manager -->
  (function (w, d, s, l, i) {
    w[l] = w[l] || [];
    w[l].push({
      'gtm.start':
          new Date().getTime(), event: 'gtm.js'
    });
    var f = d.getElementsByTagName(s)[0],
        j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : '';
    j.async = true;
    j.src =
        'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
    f.parentNode.insertBefore(j, f);
  })(window, document, 'script', 'dataLayer', 'GTM-PBHJ4M');

  checkInitGoogleAnalytics();
  mindboxAnonimEditSetEntrancePage();

  if (getCookie('_delay_mindbox_request') !== undefined) {
    setTimeout(() => {
      mindboxAnonimEdit();
    }, 500);
  }
});


// фикс проблемы с обводкой "Прямой эфир"
window.onload = function () {
  const item = document.querySelector('.info .info__text .stroke-wrapper');
  item.style.zIndex = "10";
  setTimeout(() => {
    item.style.zIndex = "10";
  }, 1000);
};






